<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      石井站<br>
站点介绍<br>
石井站位于金田路与绿茵南路（规划路）交叉口西侧、金田路与绿景路（规划路）丁字路口，车站沿金田路呈东西向布置。车站周围主要以居民用房和工业厂房为主。车站设置有4个出入口。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:34	23:43	16号线	5分32秒	6分53秒<br>
田心	06:01	23:05	16号线	5分32秒	6分53秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:43	23:43	16号线	5分50秒	6分钟-9分钟<br>
田心	06:04	23:05	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:43	00:43	16号线	5分50秒	6分钟-9分钟<br>
田心	06:04	00:05	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
金田路南侧（西）、石井社区警务室、深圳技术大学实训基地、名城路（西）<br><br>
B出入口:<br>
金田路南侧（东）、消防站、名城路（东）、念慈楼、石井社区公园、<br><br>
C出入口:<br>
金田路北侧（东）、横塘路、石井小区、绿荫南路、深圳农业科技产业示范园区<br><br>
D出入口:<br>
金田路北侧（西）、石井社区工作站、  石井社区居委会、石井社区退役军人服务站、 石井社区健康服务中心、同心幼儿园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 石井社区<br>
939A、B762、B951、E17、M195、M294、M576<br><br>
B出入口:<br>
公交站名： 石井村<br>
939B、B762、M576<br><br>
B出入口:<br>
公交站名： C出入口石井村<br>
939B、B762、M576<br><br>
D出入口:<br>
公交站名： 石井社区<br>
939A、B762、B951、E17、M195、M294、M576<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>